import axios from 'axios'
import { getAuth } from 'firebase/auth'

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosClient.interceptors.request.use(async config => {
  const token = await getAuth().currentUser?.getIdToken()
  config.headers.Authorization = `Bearer ${token}`

  return config
})

export default axiosClient
